/* eslint-disable no-param-reassign */
import apiCodesMap from '../assets/api-codes.json';
import config from '../config';
import { POLICY_TYPE_CODES } from '../constants/constants';

function getLanguage() {
  return window.location.pathname.split('/').find(s => !!s) || 'en';
}

function fixDeepLink(originalDeepLink, lang) {
  let fixedDeepLink = originalDeepLink;

  if (originalDeepLink.indexOf('identityFEPath') !== -1) {
    fixedDeepLink = `${originalDeepLink}`.replace(
      '{lang}/{identityFEPath}',
      `${lang}/${config.webview.identityFEPath}`,
    );
  } else if (originalDeepLink.indexOf('lifeFEPath') !== -1) {
    fixedDeepLink = `${originalDeepLink}`.replace(
      '{lang}/{lifeFEPath}',
      `${lang}/${config.webview.lifeFEPath}`,
    );
  } else if (originalDeepLink.indexOf('myAXAAppQRCodeUrl') !== -1) {
    fixedDeepLink = `${originalDeepLink}`.replace(
      '{myAXAAppQRCodeUrl}',
      `${config.myAXAAppQRCodeUrl}`,
    );
  }

  return fixedDeepLink;
}

function fixErrorCode({ errorCode, apiCode, featureCode, policyTypeCode } = {}) {
  // HKEMMA-62365: apply to only pnc
  // this return statement should be removed/updated when the error code fix is extended to other policy types
  if (policyTypeCode !== POLICY_TYPE_CODES.pnc) return errorCode;

  return `${policyTypeCode}${featureCode}${apiCode}`;
}

function fixErrorConfig(errorConfig, { featureCode, policyTypeCode } = {}) {
  const lang = getLanguage();
  const result = { ...errorConfig };

  // fix buttons deep links
  if (result.buttons) {
    result.buttons = errorConfig.buttons.map(item => {
      return item.deeplink
        ? { ...item, deeplink: fixDeepLink(item.deeplink, lang) }
        : item;
    });
  }

  // HKEMMA-62365: append lob code (namely policy type code) and feature code to error code
  if (result.errorCode) {
    result.errorCode = fixErrorCode({
      errorCode: result.errorCode,
      apiCode: result.apiCode,
      featureCode,
      policyTypeCode,
    });
  }

  return result;
}

export function getErrorConfig({ apiCode, featureCode, policyTypeCode } = {}) {
  const { data } = apiCodesMap;
  // find error code config with feature & api code matched
  // if not found, fall back to api code matched
  const errorConfigs = data[apiCode] || [];
  const errorConfigFound =
    errorConfigs.find(item => {
      if (item.featureCode === featureCode && item.apiCode === apiCode) return true;

      return false;
    }) || errorConfigs[0];

  // early return if no error code found
  if (!errorConfigFound) return null;

  const fixed = fixErrorConfig(errorConfigFound, { featureCode, policyTypeCode });
  return fixed;
}
